var _LegacyAccountManager_instances, _LegacyAccountManager_config, _LegacyAccountManager_token, _LegacyAccountManager_getTokenFromCookie, _LegacyAccountManager_getCookieByName;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { singleton } from 'tsyringe';
export class Agent {
}
let LegacyAccountManager = class LegacyAccountManager {
    constructor() {
        _LegacyAccountManager_instances.add(this);
        this.isReady = false;
        _LegacyAccountManager_config.set(this, void 0);
        _LegacyAccountManager_token.set(this, void 0);
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _LegacyAccountManager_config, config, "f");
            if (!__classPrivateFieldGet(this, _LegacyAccountManager_config, "f").legacyAccount.credentialKey) {
                __classPrivateFieldGet(this, _LegacyAccountManager_config, "f").legacyAccount.credentialKey = 'd';
            }
            yield __classPrivateFieldGet(this, _LegacyAccountManager_instances, "m", _LegacyAccountManager_getTokenFromCookie).call(this);
            this.isReady = true;
        });
    }
    getToken() {
        return __classPrivateFieldGet(this, _LegacyAccountManager_token, "f");
    }
    redirectToLogin() {
        const returnUrl = window.encodeURIComponent(window.location.href);
        window.location.href = `${__classPrivateFieldGet(this, _LegacyAccountManager_config, "f").legacyAccount.loginUrl}/?returnUrl=${returnUrl}`;
    }
    logout() {
        window.location.href = __classPrivateFieldGet(this, _LegacyAccountManager_config, "f").legacyAccount.logoutUrl;
    }
};
_LegacyAccountManager_config = new WeakMap(), _LegacyAccountManager_token = new WeakMap(), _LegacyAccountManager_instances = new WeakSet(), _LegacyAccountManager_getTokenFromCookie = function _LegacyAccountManager_getTokenFromCookie() {
    return __awaiter(this, void 0, void 0, function* () {
        __classPrivateFieldSet(this, _LegacyAccountManager_token, __classPrivateFieldGet(this, _LegacyAccountManager_instances, "m", _LegacyAccountManager_getCookieByName).call(this, __classPrivateFieldGet(this, _LegacyAccountManager_config, "f").legacyAccount.credentialKey), "f");
    });
}, _LegacyAccountManager_getCookieByName = function _LegacyAccountManager_getCookieByName(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
        return parts.pop().split(';').shift();
};
LegacyAccountManager = __decorate([
    singleton()
], LegacyAccountManager);
export { LegacyAccountManager };
